<template>
  <article :id="$vnode.key" class="col-12">
    <custom-callout
      ref="callout"
      :has-toggle="false"
      :has-border="false"
      class="mt-2 mb-3"
      class-main="bg-white"
    >
      <div class="row">
        <div class="col-12 col-md-3">
          <div class="info-text-title">Centro:</div>
          <p class="info-text mb-0">
            {{ value.center.name || '-' }}
          </p>
        </div>
        <div class="col-12 col-md-3">
          <div class="info-text-title">Municipio:</div>
          <p class="info-text mb-0">
            {{ value.municipality.name || '-' }}
          </p>
        </div>
        <div class="col-12 col-md-3">
          <div class="info-text-title">Escuela:</div>
          <p class="info-text mb-0">
            {{ value.school.value.fullName || '-' }}
          </p>
        </div>
        <div
          v-if="!readonly"
          class="col-12 col-md-3 px-0 mt-2 mt-md-0 d-md-flex justify-content-end"
        >
          <div class="align-self-center mr-5">
            <CustomCheckbox
              :value="checked"
              class="custom-checkbox__extended"
              @input="(val) => onChecked(val)"
            />
          </div>
        </div>
        <div
          v-if="readonly && !value.itemNumber"
          class="col-12 col-md-3 d-flex justify-content-end"
        >
          <action-button
            variant="outline-danger m-1"
            i="fas fa-minus-circle"
            text="Remover"
            @click="$emit('on-remove', value)"
          />
        </div>
      </div>
      <div class="row border-divider my-4" />
      <div class="row mr-0">
        <div class="col-12 col-md-3">
          <div class="info-text-title">Número de Solicitud:</div>
          <p class="info-text mb-0">
            {{ value.request.name || '-' }}
          </p>
        </div>
        <div class="col-12 col-md-3">
          <div class="info-text-title">Fecha de Solicitud:</div>
          <p class="info-text mb-0">
            {{ value.request.value.requestDate | date }}
          </p>
        </div>
        <div class="col-12 col-md-3">
          <div class="info-text-title">Cantidad de Artículos:</div>
          <p class="info-text mb-0">
            {{ value.quantity }}
          </p>
        </div>
        <div
          class="col-12 col-md-3 px-0 mt-2 mt-md-0 d-md-flex justify-content-center"
        >
          <div class="align-self-center">
            <CustomInput
              v-model="modifiedQuantity"
              label="Cantidad Modificada (opcional):"
              :disabled="!checked || readonly"
              type="number"
              class="height-fixed label-gray"
              @input="onModifiedQuantityChange()"
            />
          </div>
        </div>
      </div>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInput from 'CustomInput';
import CustomCheckbox from 'CheckBox';
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';
export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    CustomInput,
    CustomCheckbox,
    ActionButton,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      default: () => false,
    },
    itemModifiedQuantity: {
      type: Number,
      default: () => null,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      modifiedQuantity: null,
    };
  },
  watch: {
    checked(value) {
      if (!value) {
        this.modifiedQuantity = null;
      }
    },
  },
  mounted() {
    this.modifiedQuantity = this.readonly
      ? this.value.quantityApproved
      : this.itemModifiedQuantity;
  },
  methods: {
    onModifiedQuantityChange() {
      if (
        this.modifiedQuantity != null &&
        this.modifiedQuantity > this.value.quantity
      ) {
        this.modifiedQuantity = this.value.quantity;
        this.ShowToast(
          'Alerta',
          'No debe exceder la cantidad de artículos disponibles.',
          'error'
        );
      }
      this.$emit(
        'onModifiedQuantityChanged',
        this.value,
        this.modifiedQuantity
      );
    },
    onChecked(val) {
      this.$emit('onChecked', val, this.value, this.modifiedQuantity);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.label-gray ::v-deep {
  .input-display > label {
    color: map.get($colors, 'gray-6');
  }
}

.info-text-title {
  color: map.get($colors, 'gray-6') !important;
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, 'black');
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}
.border-divider {
  content: '';
  width: 100%;
  border-bottom: 1px solid map.get($colors, 'gray-5');
}

.custom-checkbox__extended ::v-deep {
  span.bg-white {
    border: 1px solid #676767 !important;
  }
}
</style>
